import React from 'react'
import { Link as GatsbyLink } from 'gatsby'
import ChevronRight from '../../images/svg-components/ChevronRight'

const Link = ({ children, to, useChevron, className, ...props }) => {
  // test to see if url is internal
  const internal = /^\/(?!\/)/.test(to)

  if (internal) {
    return (
      <GatsbyLink to={to} className={className} {...props}>
        {children}
        {useChevron &&
          <span className='link--chev'>
            <ChevronRight />
          </span>
        }
      </GatsbyLink>
    )
  }
  return (
    <a
      href={to}
      target='_blank'
      rel='noopener noreferrer'
      className={className}
      {...props}
    >
      {children}
      {useChevron &&
        <span className='link--chev'>
          <ChevronRight />
        </span>
      }
    </a>
  )
}

export default Link
